<div class="input" id="noOfGuest-trigger">
  <span>{{ noOfAdults }} Adults, {{ noOfChildren }} Children, {{ noOfInfants }} Infants</span>
</div>
<ion-popover trigger="noOfGuest-trigger" triggerAction="click" side="top" alignment="end">
  <ng-template class="popover">
    <div class="w-100 py-2 px-3">
      <div class="d-flex justify-content-between align-items-center mb-1">
        <div>
          <p class="label">Adults</p>
          
        </div>
        <div>
          <app-increment-number-input [(ngModel)]="noOfAdults" (numberChange)="updateGuests()" [max]="999"></app-increment-number-input>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center mb-1">
        <div>
          <p class="label">Children</p>
          <p class="sm-label">Age 2 to 12</p>
        </div>
        <div>
          <app-increment-number-input [(ngModel)]="noOfChildren" (numberChange)="updateGuests()" [max]="999"></app-increment-number-input>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center mb-0">
        <div>
          <p class="label">Infants</p>
          <p class="sm-label">Age under 2</p>
        </div>
        <div>
          <app-increment-number-input [(ngModel)]="noOfInfants" (numberChange)="updateGuests()" [max]="999"></app-increment-number-input>
        </div>
      </div>
    
    </div>
  </ng-template>
</ion-popover>
